import { render, staticRenderFns } from "./Automatic.vue?vue&type=template&id=0c954b5a&"
import script from "./Automatic.vue?vue&type=script&lang=js&"
export * from "./Automatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports